export default __webpack_public_path__ + "static/media/Group 10498.7f73db97.png";